module.exports = __webpack_public_path__ + "static/media/truck-fast-outline.1c338491.svg";